




















































import { ValidationObserver } from 'vee-validate'
import { Component, Emit, Model, Prop, Vue, Watch } from 'vue-property-decorator'
import { ListItem } from '@/layouts/components'
import { MenuType, ShopSettings, ShopSettingsResourcePayload } from '@/models'
import SwitchListItem from './SwitchListItem.vue'

@Component({
  components: {
    ListItem,
    SwitchListItem,
    ValidationObserver
  }
})
export default class SettingsForm extends Vue {
  @Model('change', { type: Object, default: null })
  readonly data!: ShopSettingsResourcePayload | null

  @Prop({ type: Object })
  readonly shopSettings!: ShopSettings | null

  @Prop({ type: Boolean, default: false })
  readonly isLocked!: boolean

  transitionDirection = [
    'opacity-0 translate-x-32',
    'opacity-0 -translate-x-32'
  ]

  isValid = false
  isActive = false

  @Watch('data', { immediate: true })
  onDataChange () {
    if (this.data === null) {
      this.isActive = false
    } else {
      this.isActive = this.data.menuType !== MenuType.LITE
    }
  }

  @Watch('isActive')
  onIsActiveChange () {
    this.updateModel()
  }

  /**
   * This is a hack because ValidationObserver does not emit a status event
   * and its validate() method returns a Promise.
   */
  setIsValid (valid: boolean) {
    this.isValid = valid

    this.$emit('update:isValid', this.isValid)
  }

  @Emit('change')
  updateModel (): ShopSettingsResourcePayload {
    return this.isActive
      ? { menuType: MenuType.FULL }
      : { menuType: MenuType.LITE }
  }

  submit () {
    if (this.isValid) {
      this.$emit('submit')
    }
  }
}
